<script lang="ts">
    import { _ } from "svelte-i18n"
    import { LasersheetLayouts, LasersheetTypes } from "../product/widgets/helper"

    let { cartItem }: { cartItem: CartItem } = $props()
    const uI = cartItem?.user_inputs
    const lSE = uI?.lasersheet_engraving
    const activeLasersheets = cartItem?.product?.lasersheet_configurator?.map((s) => s.lasersheet_nr)
    const qrCode = cartItem?.qr_code
</script>

{#if uI && Object.keys(uI).length}
    <div class="variant">
        {#if qrCode}
            <b>{$_("cart.qr-code")}:</b>
            {qrCode.code}<br />
        {/if}
        {#if uI?.engraving_line_1 !== undefined}
            <b>{$_("cart.engraving-line-1")}:</b>
            {#if uI.engraving_line_1}
                {uI.engraving_line_1}
            {:else}
                <span class="unwritten">{$_("cart.unwritten")}</span>
            {/if}<br />
        {/if}
        {#if uI?.engraving_line_2 !== undefined}
            <b>{$_("cart.engraving-line-2")}:</b>
            {#if uI.engraving_line_2}
                {uI.engraving_line_2}
            {:else}
                <span class="unwritten">{$_("cart.unwritten")}</span>
            {/if}<br />
        {/if}
        {#if uI?.engraving_line_3 !== undefined}
            <b>{$_("cart.engraving-line-3")}:</b>
            {#if uI.engraving_line_3}
                {uI.engraving_line_3}
            {:else}
                <span class="unwritten">{$_("cart.unwritten")}</span>
            {/if}<br />
        {/if}
        {#if uI?.key_number}
            <b>{$_("cart.key-number")}:</b>
            {#if uI.key_number == -1}
                {$_("cart.whatever")}
            {:else}
                {uI.key_number}
            {/if}
            <br />
        {/if}

        {#if lSE && activeLasersheets && activeLasersheets.length}
            {#if activeLasersheets.includes(LasersheetTypes.NameShield)}
                <b>{$_("cart.name-shield")}:</b>
                {#if lSE.sheet2_line1}
                    {lSE.sheet2_line1}
                {:else}
                    <span class="unwritten">{$_("cart.unwritten")}</span>
                {/if}<br />
            {/if}
            {#if activeLasersheets.includes(LasersheetTypes.MainShield) && activeLasersheets.length > 1}
                <br />
            {/if}
            {#if activeLasersheets.includes(LasersheetTypes.MainShield)}
                <b>{$_("cart.lasersheetMainShield")}</b> <br />
                <b>{$_("cart.lasersheetLayout")}:</b>
                {#if lSE.sheet1_layout == LasersheetLayouts.Centered}
                    {$_("cart.lasersheetLayoutCenter")}
                {:else if lSE.sheet1_layout == LasersheetLayouts.Justified}
                    {$_("cart.lasersheetLayoutJustified")}
                {/if}<br />
                <b>{$_("cart.lasersheetLine1")}:</b>
                {#if lSE.sheet1_line1}
                    {lSE.sheet1_line1}
                {:else}
                    <span class="unwritten">{$_("cart.unwritten")}</span>
                {/if}<br />
                <b>{$_("cart.lasersheetLine2")}:</b>
                {#if lSE.sheet1_line2}
                    {lSE.sheet1_line2}
                {:else}
                    <span class="unwritten">{$_("cart.unwritten")}</span>
                {/if}<br />
                <b>{$_("cart.lasersheetLine3")}:</b>
                {#if lSE.sheet1_line3}
                    {lSE.sheet1_line3}
                {:else}
                    <span class="unwritten">{$_("cart.unwritten")}</span>
                {/if}<br />
                <b>{$_("cart.lasersheetHouseNr")}:</b>
                {#if lSE.sheet1_houseNr}
                    {lSE.sheet1_houseNr}
                {:else}
                    <span class="unwritten">{$_("cart.unwritten")}</span>
                {/if}<br />
                <b>{$_("cart.lasersheetStreet")}:</b>
                {#if lSE.sheet1_street}
                    {lSE.sheet1_street}
                {:else}
                    <span class="unwritten">{$_("cart.unwritten")}</span>
                {/if}<br />
            {/if}

            {#if activeLasersheets.includes(LasersheetTypes.FooterShield)}
                <b>{$_("cart.newspaper-shield")}:</b>
                {lSE.sheet3_line1}<br />
            {/if}

            {#if lSE.font}
                <b>{$_("cart.lasersheetFont")}:</b>
                {$_("cart." + lSE.font)}<br />
            {/if}
        {/if}
    </div>
{:else if qrCode}
    <div class="variant">
        <b>{$_("cart.qr-code")}:</b>
        {qrCode.code}<br />
    </div>
{/if}

<style>
    .unwritten {
        color: #999;
        font-style: italic;
        opacity: 0.7;
    }
</style>
